var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1615 13.9938C13.7704 13.9938 14.0194 13.5878 14.0124 13.0788C13.9814 11.1619 14.7264 10.1299 16.0713 11.4749C17.5593 12.9628 17.8673 13.9938 19.6742 13.9938H22.874C23.682 13.9938 24 13.7338 24 13.3258C24 12.4628 22.5791 10.9399 21.3751 9.82187C19.6892 8.25689 19.6102 8.21989 21.0621 6.33592C22.863 3.99695 25.2189 0.999987 23.135 0.999987H19.1542C18.3822 0.999987 18.3262 1.43498 18.0512 2.08297C17.0563 4.42994 15.1654 7.4699 14.4474 7.00491C13.6964 6.51991 14.0404 4.59894 14.0974 1.74398C14.1124 0.989987 14.1084 0.472994 12.9565 0.204997C12.3275 0.0599991 11.7155 0 11.1475 0C8.87463 0 7.3067 0.952988 8.19766 1.11899C9.76859 1.41198 9.6176 4.81094 9.25161 6.27892C8.61364 8.83488 6.21574 4.25494 5.21678 1.97397C4.97579 1.42598 4.9018 0.999987 4.04183 0.999987H0.786967C0.294988 0.999987 0 1.15998 0 1.51598C0 2.11797 2.95988 8.23589 5.78576 11.2859C8.54164 14.2608 11.2655 13.9938 13.1615 13.9938V13.9938Z",
    fill: "#375B6B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.df00a00f76ef54cc847821b761e869a1.svg";
export { ForwardRef as ReactComponent };